import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../../../hooks/theme"


export const useStyles = () => {
  const { colors: color } = useContextState()
  const { breakpoints } = useTheme()
  return {
    createTitle: {
        // fontSize: '1.4rem',
        paddingBottom: '0px',
        lineHeight: '1',
        padding: '20px 20px 0',
    },
        contentRight: {
        overflowY: 'auto',
        maxHeight: 'calc(90vh - 110px)'
    },
        content: {
        padding: '0 20px',
        paddingTop: '20px',
    },
    footerBtn: {
        marginTop: "20px",
        paddingTop: '0px',
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: '0 20px 20px',
    },
    permissionTable: (payload: { loading: boolean }) => ({
      padding: '20px',
      paddingBottom: '0px',
      ...!!payload.loading && {
        position: 'relative',
        top: '25%'
      }
    }),
    saveButton: {
      width:'100%',
      display:'flex',
      justifyContent:'end',
      paddingTop:'16px',
      paddingRight:'16px',
      gap:2,
      flexWrap:' wrap',
      [breakpoints.down(830)]: {
        flexDirection:'column',
        paddingLeft:'20px',
        gap:2,
      },
    },
    checkBox: { 
      padding: '0px' 
    },
    drawerTitle: {
      color: color.color13,
      '&.wSc':{
        whiteSpace: 'pre-line'
      }
    },
  }
}
